import {ident} from './';

const undef = ident();

export {undef};
